var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightbb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 21.7071C30.0976 21.3166 30.0976 20.6834 29.7071 20.2929L23.3431 13.9289C22.9526 13.5384 22.3195 13.5384 21.9289 13.9289C21.5384 14.3195 21.5384 14.9526 21.9289 15.3431L27.5858 21L21.9289 26.6569C21.5384 27.0474 21.5384 27.6805 21.9289 28.0711C22.3195 28.4616 22.9526 28.4616 23.3431 28.0711L29.7071 21.7071ZM12 22H29V20H12V22Z",
    fill: "#1B1E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightbb);
export default __webpack_public_path__ + "static/media/rightbb.09fb8224df555691c72ffca3eb9dc4da.svg";
export { ForwardRef as ReactComponent };